import type { ReportAuthorizationInfo, SharedWithEntity } from "../../../../../api/types/svTypes.ts";

interface GroupSharingFollower {
  groupId: string;
  inheritFromParent: boolean;
  authorization: ReportAuthorizationInfo;
}

export const applyGroupSharedWith = <T extends GroupSharingFollower>(
  items: T[],
  groupId: string,
  sharedWith: SharedWithEntity[]
): T[] =>
  items.map((item) =>
    item.inheritFromParent && item.groupId === groupId
      ? { ...item, authorization: { ...item.authorization, sharedWith, private: sharedWith.length === 0 } }
      : item
  );
